import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { PGWContractContainerModel} from "../../../../../models/aggregates/pgw/pgw-contract.model";
import {
  ApiVisa,
  BaseApiTemplateService,
  Core2Config,
  PagingResponseModel,
} from "../shared";
import {
  PGWContractQueryCriteriaClass,
  PGWContractCriteriaModelQuery,
} from "../../criteria/pgw/pgw-contract-criteria.model";

@Injectable({
  providedIn: "root",
})
export class PGWContractService extends BaseApiTemplateService<PGWContractContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.PGW_PREFIX + "contracts";
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.PGW_PREFIX + "contracts";
    this.httpClient = http;
  }

  getPGWContractByCriteria(
    visa: ApiVisa,
    criteria?: PGWContractQueryCriteriaClass
  ): Observable<PagingResponseModel<PGWContractContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const buildPGWContractCriteria = new PGWContractCriteriaModelQuery(criteria);
    console.log("query", buildPGWContractCriteria.query);
    return this.httpClient.get<PagingResponseModel<PGWContractContainerModel>>(
      this.apiUrl + "/query?" + buildPGWContractCriteria.query,
      this.getHttpHeader(visa)
    );
  }
}
